import axios from '@lib/axios';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export interface Inputs {
  companyIds: string[];
  startDate: Date;
  endDate: Date;
}

interface HookProps {
  onSuccess?: (filepath: string) => void;
  onError?: (error: AxiosResponse) => void;
}

export const useAnalyticsReport = ({ onSuccess, onError }: HookProps) => {
  const { mutate: onGenerateAnalyticsReport, ...rest } = useMutation({
    mutationFn: async (params: Inputs) => {
      const {
        data: { filename },
      } = await axios.get(`/reports/analytics`, { params });

      return filename;
    },
    onSuccess,
    onError,
  });

  return { onGenerateAnalyticsReport, ...rest };
};
